module.exports = __webpack_public_path__ + "static/img/1.a8d400c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/kocom/1.png
// module id = z+6g
// module chunks = 1